<script setup lang="ts">
import { ref, computed, watch, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import OutletListSelector, { type OutLet } from './OutletListSelector.vue';
import { getPlatform } from '@/utils/misc';

const { t } = useI18n();

const $emit = defineEmits(['change', 'update:modelValue', 'close', 'select']);
const $props = defineProps({
    modelValue: {
        type: Boolean,
    },
    outlets: {
        type: Array as PropType<OutLet[]>,
        required: true,
        default: () => [],
    },
});

const visible = ref($props.modelValue);

const isMobile = computed(() => {
    return getPlatform() === 'mobile-web';
});

// 监听 modelValue 变化
watch(() => $props.modelValue, (newVal) => {
    visible.value = newVal;
});

// 监听 visible 变化
watch(visible, (newVal) => {
    $emit('update:modelValue', newVal);
    if (!newVal) {
        $emit('close');
    }
});

// 处理商户选择
const handleMerchantSelect = (outlet: OutLet) => {
    $emit('select', outlet);
    handleClose();
};

// 处理关闭
const handleClose = () => {
    $emit('change', false);
    $emit('update:modelValue', false);
    $emit('close', false);
};
</script>

<template>
    <x-dialog v-model="visible" :width="isMobile ? '90%' : '770px'" :title="t('merchant.selectMerchant')"
        :before-close="handleClose" @close="handleClose" :close-on-click-modal="false">
        <div class="w-[350px] overflow-hidden">
            <OutletListSelector :outlets="outlets" @select="handleMerchantSelect" height="550px"/>
        </div>
    </x-dialog>
</template>
